import { ModalCloseButton, Text, VStack } from '@chakra-ui/react';

import {
    Alert,
    AlertDescription,
    AlertIcon,
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from '@/components/v4';

const DeleteConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    deleteCount,
}) => {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Modal
            closeOnOverlayClick={false}
            isCentered
            isOpen={isOpen}
            onClose={onClose}
            size="lg">
            <ModalOverlay backdropFilter="blur(10px)" />
            <ModalContent>
                <ModalHeader>Delete TRS Registration</ModalHeader>
                <ModalCloseButton />
                <ModalBody py={4}>
                    <VStack spacing={4} align="stretch">
                        <Alert status="error">
                            <AlertIcon />
                            <AlertDescription>
                                Are you sure you want to continue? This action
                                cannot be undone.
                            </AlertDescription>
                        </Alert>

                        <Text fontSize="sm">
                            The deleted{' '}
                            {deleteCount > 1 ? 'registrations' : 'registration'}{' '}
                            will be permanently removed from the system.
                        </Text>
                    </VStack>
                </ModalBody>
                <ModalFooter justifyContent="flex-end" gap={3}>
                    <Button minW={120} variant="outline" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        minW={120}
                        colorScheme="red"
                        onClick={handleConfirm}
                        _hover={{
                            bg: 'red.600',
                        }}>
                        Delete
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteConfirmationModal;
